module.exports = __webpack_public_path__ + "img/banner_ylfw.7a8fe3cb.png";